import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper';
import AccountCard from './AccountCard';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const AccountsCarousel = ({ packages, selectedPackage, onSelectPackage }) => {
  const swiperRef = useRef(null);

  return (
    <div className="accounts-carousel-wrapper">
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        centeredSlides={true}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        modules={[Pagination, Navigation]}
        className="accounts-swiper"
      >
        {packages.map((pkg) => (
          <SwiperSlide key={pkg.id}>
            <div className="swiper-slide-content">
              <AccountCard
                packageData={pkg}
                isSelected={selectedPackage?.id === pkg.id}
                onSelect={onSelectPackage}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <button
        onClick={() => swiperRef.current?.slidePrev()}
        className="carousel-nav-btn carousel-nav-prev"
        aria-label="Previous package"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 10 20" fill="none">
          <path
            d="M8.5 2.07129L1.5 10.0713L8.5 18.0713"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <button
        onClick={() => swiperRef.current?.slideNext()}
        className="carousel-nav-btn carousel-nav-next"
        aria-label="Next package"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 10 20" fill="none">
          <path
            d="M1.5 18.0713L8.5 10.0713L1.5 2.07129"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export default AccountsCarousel;

